import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttritionUpdatesComponent } from './attrition-updates/attrition-updates.component';
import { RetentionDataComponent } from './retention-data/retention-data.component';
import { RowComponent, ColComponent } from '@coreui/angular';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  standalone: true,
  imports: [CommonModule, AttritionUpdatesComponent, RetentionDataComponent, RowComponent, ColComponent]
})
export class ReportsComponent {
  activeTab: 'attrition' | 'retention' = 'attrition';

  setTab(tab: 'attrition' | 'retention') {
    this.activeTab = tab;
  }
}
